import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4179020d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4179020d&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/liando-portal_pdr2/dyc-portal-pc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4179020d')) {
      api.createRecord('4179020d', component.options)
    } else {
      api.reload('4179020d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4179020d&", function () {
      api.rerender('4179020d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/link/index.vue"
export default component.exports